export type AccessLevel = "full" | "partial" | "none";

/** Grant state for a node: every key, some keys, or none. Empty key lists are none. */
export function accessLevel(selected: ReadonlySet<string>, keys: readonly string[]): AccessLevel {
  if (keys.length === 0) return "none";
  let granted = 0;
  for (const key of keys) {
    if (selected.has(key)) granted += 1;
  }
  if (granted === 0) return "none";
  if (granted === keys.length) return "full";
  return "partial";
}
